// Reactインポート
import React from "react";
import { Link } from "react-router-dom";
// ゲットナビゲータ
import Nav from "./Nav";

// ヘッダースタイル
import "../css/Header.scss";

// ロゴイメージ
import logo from "../img/top/logo.png";

function Header() {
  return (
    <header id="header" className="clearfix">
      <div className="header-background">
        <h1 className="header-logo">
          <Link to="/">
            <div className="header-img img1">
              <img src={logo} alt=""></img>
            </div>
          </Link>
        </h1>
        <div className="block">
          <Nav />
        </div>
      </div>
    </header>
  );
}

export default Header;
